import AppDialog from "../../../components/Common/AppDialog";
import ImportantNotice from "../../../components/Common/ImportantNotice";

export default function ReactivateAlert({ open, close, handleSubmit, windowWidth }) {
    return (
        <AppDialog
            title={'Reactivate Advert'}
            open={open}
            close={close}
            positiveTitle={'Reactivate now'}
            positivePress={() => handleSubmit()}
            cancelButton={true}
            width={'40%'}
            isMobile={windowWidth <= 768}
        >
            <div>Are you sure you want to reactivate this advert and publish it again?</div>
            <div className="my-2">Once reactivated,</div>
            <ul className="subheader-2" style={{ padding: 5, paddingInline: 15 }}>
                <li className="mb-2">The advert will be republished and visible in search results.</li>
                <li className="mb-2">The “Reserved” badge will be removed immediately.</li>
                <li className="mb-2">All advert details remain unchanged.</li>
            </ul>
            <div className="my-2">
                <ImportantNotice
                    iconName={'solar:lightbulb-linear'}
                    iconColor={'#1D1B1B'}
                    backgroundColor={'#F0F0F0'}
                    color={'#1D1B1B'}
                    message={'This advert is currently marked as Reserved.'}
                />
            </div>
        </AppDialog>
    )
}